import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewEncapsulation
} from '@angular/core';
import { SegmentControlItemComponent } from "../segment-control-item/segment-control-item.component";
import { SegmentWidth } from './segment-width.enum';
import { SegmentStyle } from "./segment-style.enum";
import { SegmentItemPadding } from "./segment-item-padding.enum";

@Component({
  selector: 'app-segment-control',
  templateUrl: './segment-control.component.html',
  styleUrl: './segment-control.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SegmentControlComponent implements AfterContentInit {
  @ContentChildren(SegmentControlItemComponent) segments!: QueryList<SegmentControlItemComponent>;

  @Input() width: SegmentWidth = SegmentWidth.Wrap;
  @Input() style: SegmentStyle = SegmentStyle.Primary;
  @Input() itemPadding: SegmentItemPadding = SegmentItemPadding.Md;

  @Output() segmentIndexChange = new EventEmitter<number>();

  public index: number = 0;

  ngAfterContentInit() {
    const selectedSegment = this.segments.find((t) => t.active);

    if (!selectedSegment) {
      // Activate the first tab by default
      if (this.segments.first) {
        this.selectSegment(this.segments.first);
        this.index = 0;
      }
    }
  }

  public selectSegmentAtIndex(index: number) {
    this.selectSegment(this.segments.toArray()[index]);
    this.index = index;
  }

  protected selectSegment(tab: SegmentControlItemComponent) {
    this.segments.forEach((t) => (t.active = false));
    tab.active = true;

    // Emit the tabIndexChange event
    const tabArray = this.segments.toArray();
    const index = tabArray.indexOf(tab);
    this.index = index;
    this.segmentIndexChange.emit(index);
  }

  protected getSegmentClasses() {
    return {
      'width-fill': this.width === SegmentWidth.Fill,
      'width-wrap': this.width === SegmentWidth.Wrap,
      'style-primary': this.style === SegmentStyle.Primary,
      'style-secondary': this.style === SegmentStyle.Secondary,
      'style-tertiary': this.style === SegmentStyle.Tertiary,
    };
  }

  protected getClasses(tab: SegmentControlItemComponent): any {
    return {
      'active': tab.active,
      'style-primary': this.style === SegmentStyle.Primary,
      'style-secondary': this.style === SegmentStyle.Secondary,
      'style-tertiary': this.style === SegmentStyle.Tertiary,
      'px-xs': this.itemPadding === SegmentItemPadding.Xs,
      'px-sm': this.itemPadding === SegmentItemPadding.Sm,
      'px-md': this.itemPadding === SegmentItemPadding.Md,
      'px-lg': this.itemPadding === SegmentItemPadding.Lg,
      'px-xl': this.itemPadding === SegmentItemPadding.Xl,
    };
  }
}

